import { get, isEmpty } from 'lodash';
import Icon from './icons';
import { DISTRIBUTION_LINK_ENDPAGE_BUTTON_TYPES } from '../constants';
import { publicAssetsPrefix } from '../../../../configuration';

class ThankYouPage {
  constructor({
    isResultPending = true,
    rewardIsFromLastPayload = false,
    reward = {},
    surveyId,
    redirectOnDemand,
    endPageSettingType,
    onDemandEndPageUrl,
  } = {}) {
    this.getText = Pollfish.ui.getText;
    this.rating = -1;
    this.hasClosed = false;
    this.shouldRender = true;
    this.isResultPending = isResultPending;
    this.reward = reward;
    this.surveyId = surveyId;
    this.redirectOnDemand = redirectOnDemand;
    this.endPageSettingType = endPageSettingType;
    this.onDemandEndPageUrl = onDemandEndPageUrl;
    this.rewardIsFromLastPayload = rewardIsFromLastPayload;

    // we don't want notifications showing on a thank you page
    Pollfish.ui.clearNotificationPrompts();
  }

  renderImg = () => {
    let img = '';
    // do not show an image if must show a campaign banner
    if (
      Pollfish.helper.hasCustomSurveyTheme() ||
      Pollfish.helper.whiteLabelEnabled()
    ) {
      return '';
    }

    if (Pollfish.helper.noSurveyAvailable && isEmpty(this.reward)) {
      img = `<img src="${publicAssetsPrefix}/img/orca.png" alt="There is no survey available" class="loading__image">`;
    } else {
      img = `<img src="${publicAssetsPrefix}/img/thankyou.png" alt="Thank you" class="loading__image">`;
    }

    return `<div class="loading__image-container">${img}</div>`;
  };

  renderSubmitBtn = () => {
    const { getText } = this;
    let btn = '';
    let btnText = getText('thank_you.non_incentive.btn_copy');

    if (this.redirectOnDemand) {
      switch (this.endPageSettingType) {
        case DISTRIBUTION_LINK_ENDPAGE_BUTTON_TYPES.DEFAULT:
          btnText = Pollfish.ui.getText(
            'thank_you_screen.distribution_button_redirect',
          );
          break;
        case DISTRIBUTION_LINK_ENDPAGE_BUTTON_TYPES.RESULTS:
          btnText = Pollfish.ui.getText(
            'thank_you_screen.distribution_button_results',
          );
          break;
        default:
      }
    }

    btn = `
      <a href="#" class="btn btn-primary btn-lg" data-btn="close-survey">
        ${btnText}
      </a>
    `;

    return `<div class="loading__submit-btn">${btn}</div>`;
  };

  renderRateSubmitBtn = () => {
    const { getText } = this;
    const btn = `
      <a href="#" class="btn btn-primary btn-lg" data-btn="rate-survey">
        ${getText('submit')}
      </a>
    `;

    return `<div class="loading__submit-btn">${btn}</div>`;
  };

  renderHeader = () => {
    let title;
    let subtitle;
    const { getText, rewardIsFromLastPayload } = this;
    if (Pollfish.helper.noSurveyAvailable && !rewardIsFromLastPayload) {
      title = getText('thank_you.no_survey_available.title');
      subtitle = getText('thank_you.no_survey_available.subtitle');
    } else {
      title = getText('thank_you.non_incentive.title');
      subtitle = getText('thank_you.non_incentive.subtitle');
    }

    if (!this.isResultPending) {
      subtitle = getText('thank_you.subtitle');
    }

    const customEndMessage = Pollfish.helper.getCustomEndMessage();
    if (customEndMessage) {
      title = customEndMessage;
      if (!this.isResultPending) {
        // we add a white-space to keep layout as it was with subtitle
        subtitle = '&nbsp;';
      }
    }

    const hideImage =
      Pollfish.helper.hasCustomSurveyTheme() ||
      Pollfish.helper.whiteLabelEnabled();

    return `
      <div class="loading__header ${
        hideImage ? 'loading__header--short' : ''
      }" data-testid="end-screen-text">
        <h1>${title}</h1>
        <p>${subtitle}</p>
      </div>
    `;
  };

  renderRating() {
    const { getText } = this;
    const starIcon = Icon({ type: 'star', color: '#8F98A9', size: 25 });
    let stars = '';
    for (let i = 1; i <= 5; i += 1) {
      stars += `
        <span class="js-star-btn btn" style="padding: 0 5px;" data-index=${i}>${starIcon}</span>
      `;
    }
    return `
      <div class="margin-lg-btm">
        <p class="margin-xs-btm">${getText('thank_you_screen.rate') ||
          'Rate the survey'}</p>
        ${stars}
      </div>`;
  }

  renderRewards() {
    if (this.isResultPending || isEmpty(this.reward)) {
      return '';
    }

    const { getText } = this;

    return `
      <div>
        <p class="margin-reset margin-xs-btm text-semi-grey">${getText(
          'offerwall.notifications.congratulations',
        )}</p>
        <p class="margin-xl-btm" style="font-size: 24px;" data-testid="earned_reward">
          <span class="font-bold">${this.reward.value}</span> ${
      this.reward.name
    }
        </p>
      </div>
    `;
  }

  render() {
    if (!this.shouldRender) {
      return '';
    }
    const { submitEmail } = this;
    const isDistributionLink = Pollfish.helper.isDistributionLink();
    let shouldHideSubmitButton = false;
    if (Pollfish.helper.hideSubmitBtn) {
      shouldHideSubmitButton = true;
    } else if (Pollfish.helper.isPreview && !isDistributionLink) {
      shouldHideSubmitButton = true;
    } else if (
      Pollfish.helper.isPreview &&
      isDistributionLink &&
      !this.redirectOnDemand
    ) {
      shouldHideSubmitButton = true;
    } else if (Pollfish.helper.isHtmlOnly && !isDistributionLink) {
      shouldHideSubmitButton = true;
    } else if (
      Pollfish.helper.isHtmlOnly &&
      isDistributionLink &&
      !this.redirectOnDemand
    ) {
      shouldHideSubmitButton = true;
    }

    const shouldRenderRating =
      !Pollfish.helper.noSurveyAvailable && !isDistributionLink;

    const thankYou = `
      <div class="main-content__home loading">
        ${this.renderHeader()}
        ${this.renderImg()}
        ${this.renderRewards()}
        <div id="rating-container">
          ${shouldRenderRating ? this.renderRating() : ''}
          ${
            shouldRenderRating && shouldHideSubmitButton
              ? this.renderRateSubmitBtn()
              : ''
          }
        </div>
        ${shouldHideSubmitButton ? '' : this.renderSubmitBtn()}
      </div>
      `;

    $('#wrapper').on('tap', '[data-btn="submit-email-btn"]', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      submitEmail();
    });

    $('#wrapper').on('tap', '[data-btn="close-survey"]', (e) => {
      const { rating } = this;
      e.preventDefault();
      e.stopImmediatePropagation();

      // always return to the user_lang translation
      Pollfish.helper.resetTranslations();
      if (rating >= 0) {
        const surveyId = Pollfish.helper.json.s_id;
        Pollfish.mobile.interface.sendToServer(
          `/v2/device/surveys/${surveyId}/rate`,
          `{"rating": "${rating}"}`,
          false,
        );
      }
      const containsSurvey = get(Pollfish, 'helper.json.containsSurvey');
      if (
        Pollfish.helper.isDistributionLink() &&
        !containsSurvey &&
        this.redirectOnDemand
      ) {
        window.location.href =
          Pollfish.helper.json.distribution_link_redirect_data.url;
        return;
      }
      if (
        Pollfish.helper.isDistributionLink() &&
        containsSurvey &&
        this.redirectOnDemand
      ) {
        if (this.onDemandEndPageUrl) {
          window.location.href = this.onDemandEndPageUrl;
          return;
        }
      } else {
        Pollfish.mobile.interface.close();
      }

      // NOTE: Not resetting these events will create duplicates the next time
      //       a thank you screen will be initialised
      $('#wrapper').off('tap', '[data-btn="close-survey"]');
      $('#wrapper').off('click', '.js-star-btn');
      if (!this.hasClosed) {
        this.hasClosed = true;
      } else {
        // this code should be unreachable. If not then a huge bug exists
        Pollfish.analytics.sendEvent(
          'bug',
          'thankYouPage',
          'Events not reset',
          1100,
        );
      }
    });

    $('#wrapper').on('tap', '[data-btn="rate-survey"]', (e) => {
      const { getText, rating } = this;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (rating >= 0) {
        const surveyId = Pollfish.helper.json.s_id;
        Pollfish.mobile.interface.sendToServer(
          `/v2/device/surveys/${surveyId}/rate`,
          `{"rating": "${rating}"}`,
          false,
        );
      }

      const thankYouText = getText(
        'offerwall.notifications.feedback_thank_you',
      );
      $('#rating-container').html(thankYouText);

      // NOTE: Not resetting these events will create duplicates the next time
      //       a thank you screen will be initialised
      $('#wrapper').off('tap', '[data-btn="rate-survey"]');
      $('#wrapper').off('click', '.js-star-btn');
    });

    $('#wrapper').on('click', '.js-star-btn', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const starIcon = Icon({ type: 'star', color: '#8F98A9', size: 25 });
      const starChecked = Icon({ type: 'star', color: '#F8D94B', size: 25 });
      const target = e.currentTarget;
      const { index } = target.dataset;
      const checkedElements = $(`#wrapper .js-star-btn:lt(${index})`);
      checkedElements.html(starChecked);
      checkedElements.attr('data-checked', true);
      this.rating = index;
      if (index < 5) {
        const unCheckedElements = $('#wrapper .js-star-btn').slice(index - 5);
        unCheckedElements.html(starIcon);
        unCheckedElements.attr('data-checked', false);
      }
    });

    return thankYou;
  }
}

export default ThankYouPage;
